import LoginScreenComponent from "./LoginScreenComponent";
import DataSource from "devextreme/data/data_source";
import {RouteComponentProps, withRouter} from "react-router";
import {connect} from "react-redux";
import {iRootDispatch, iRootState, select} from "../../../store/store";

interface LoginScreenStateProps {
    isLogged?: boolean
}

interface LoginScreenDispatchProps {
    //
    login?: (username: string, password: string) => Promise<void>;
}

const selection = () => select((_models) => ({}))

const mapStateToProps = (state: iRootState, ownProps: RouteComponentProps<{}>): LoginScreenStateProps => ({
    isLogged: state.Identity.isLogged,
    //
    ...selection()(state),
})

const mapDispatch = (_dispatch: iRootDispatch, _ownDispatch: LoginScreenDispatchProps) => ({

    login: (username: string, password: string) => {
        // @ts-ignore
        return _dispatch.Identity.login({username, password});
    },
    //
    ..._ownDispatch
} as LoginScreenDispatchProps);

type connectedProps =
    LoginScreenStateProps
    & ReturnType<typeof mapDispatch>
export type LoginScreenProps = connectedProps

export const LoginScreen = withRouter(connect(
    mapStateToProps,
    mapDispatch as any
)(LoginScreenComponent));
